import { useFormik } from "formik";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { login } from "../redux/authCrud";
import * as auth from "../redux/authRedux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import API from "../../../helpers/devApi";

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: "",
  password: "",
};

function Login(props) {
  const [companyList, setCompanyList] = useState([]);
  const { intl } = props;
  const { authToken, loading } = useSelector((state) => state.auth);
  const [error, setError] = useState("");
  const [companyId, setCompanyId] = useState("");

  // useLayoutEffect(() => {
  //   if (authToken && Object.keys(authToken).length > 0) {
  //     props.history.push("/dashboard");
  //   } else {
  //     setTimeout(() => {
  //       window.location.href = `${process.env.REACT_APP_ERP_FE}`;
  //     }, 5000);
  //   }
  // }, [authToken, props.history]);

  const LoginSchema = Yup.object().shape({
    // email: Yup.string()
    //   .email("Wrong email format")
    //   .min(3, "Minimum 3 symbols")
    //   .max(50, "Maximum 50 symbols")
    //   .required(),

    email: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,

    validationSchema: LoginSchema,
    onSubmit: (values, { resetForm, setSubmitting, setStatus }) => {
      login(values.email, values.password)
        .then((res) => {
          if (res?.data?.success) {
            localStorage.setItem("lang", "English");
            props.login(res?.data?.data?.access_token);
          } else {
            setError(res.message);
          }
        })
        .catch(() => {
          setError("something went wrong");
        })
        .finally(() => {
          setSubmitting(false);
        });
      resetForm();
    },
  });

  const getCompanyList = async () => {
    await API.get("/companies")
      .then((res) => {
        if (!res.data.error) {
          if (res.data.data) {
            setCompanyList(res.data.data.Companies);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useLayoutEffect(() => {}, []);

  return null;
}

export default injectIntl(connect(null, auth.actions)(Login));
